import i18next from 'i18next';

const formatDuration = (seconds: number) => {
    if (seconds < 60) {
        return i18next.t('datetime.seconds', { count: seconds });
    }

    const remainingSeconds = seconds % 60;

    return `${i18next.t('datetime.minutes', {
        count: Math.floor(seconds / 60),
    })} ${
        remainingSeconds > 0
            ? i18next.t('datetime.seconds', { count: remainingSeconds })
            : ''
    }`;
};

export default formatDuration;
